import lozad from 'lozad';
import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';

import { IProduct, IProductEdp } from '@/components/pdp/IProduct';
import { getFindMine } from '@/external/service/findmine.service';
import { isConsentCategoryDisabled } from '@/tscapi/utils/consent';
import { Cookie } from '@/tscapi/utils/cookie';

import { FindmineCarousel } from './FindmineCarousel';

export interface FindmineProps {
    SelectedEdpItem: IProductEdp;
    productData: IProduct;
}

export const Findmine = ({ SelectedEdpItem, productData }: FindmineProps) => {
    const queryStrings = ['www.tsc.ca', 'origin1.tsc.ca', 'origin1s.tsc.ca'];

    const prodAppID = '04A3499628541E4C3995';
    const stagingAppID = '3AE190C3C1D080D096C1';
    const pageUrl = window.location.hostname;
    const isProd = includes(queryStrings, pageUrl);
    const findmineAppID = isProd ? prodAppID : stagingAppID;
    const findmineUrl = 'api.findmine.com';
    const domNode = document.getElementById('findMine');
    const [findmineData, setFindmineData] = useState(null);
    const [isLooksAvailable, setIsLooksAvailable] = useState(false);
    const [mcid, setMcid] = useState('');

    function includes(array, element) {
        return array.indexOf(element) >= 0;
    }

    const processData = useCallback((responseData) => {
        //format findmine data response, ie. add dash in itemNo
        const dataClone = { ...responseData };
        if (dataClone.looks) {
            dataClone.looks.forEach((look, index) => {
                if (look.items) {
                    look.items.forEach((items, j) => {
                        if (items.details.ItemNo) {
                            dataClone.looks[index].items[j].details.ItemNo =
                                items.details.ItemNo.substring(0, 3) + '-' + items.details.ItemNo.substring(3, 6);
                        }
                    });
                }
            });
        }
        // set state true if any looks returned
        if (typeof dataClone.looks != 'undefined' && dataClone.looks.length > 0) {
            setIsLooksAvailable(true);
            //there is no findmine so unhide teaser text (product overview text)
            const elem = document.getElementById('divProductTeaser');
            if (elem) {
                elem.style.display = 'block';
            }
            hideMayWeSuggest();
        } else {
            setIsLooksAvailable(false);
            unHideMayWeSuggest();
        }
        return dataClone;
    }, []);
    const unHideMayWeSuggest = () => {
        if (document.getElementById('divCuratedProductRecs')) {
            document.getElementById('divCuratedProductRecs').classList.remove('hidden');
            const observer = lozad();
            observer.observe();
            //there is no may we suggest so unhide teaser text (product overview text)
            if (document.getElementById('divProductTeaser')) {
                document.getElementById('divProductTeaser').style.display = 'block';
            }
        }
        //unhide title
        if (document.getElementById('findmine__header-wrap')) {
            document.getElementById('findmine__header-wrap').classList.add('hidden');
        }
    };
    const hideMayWeSuggest = () => {
        if (document.getElementById('divCuratedProductRecs')) {
            document.getElementById('divCuratedProductRecs').classList.add('hidden');
        }
        //hide title
        if (document.getElementById('findmine__header-wrap')) {
            document.getElementById('findmine__header-wrap').classList.add('hidden');
        }
    };
    const getFindMineData = useCallback(
        (mcID) => {
            const edpData = SelectedEdpItem;
            const configData = {
                findmineID: findmineAppID,
                findmineUrl: findmineUrl,
                productID: edpData.ItemNo,
                productColourID: edpData.StyleDimensionId,
                productPrice: edpData.AppliedPrice,
                productInStock: edpData.Inventory > 0 ? true : false,
            };
            getFindMine(
                configData,
                (responseData) => {
                    if (responseData.result == 'error') {
                        //no looks returned
                        setFindmineData(processData(responseData));
                    } else {
                        setFindmineData(processData(responseData));
                    }
                },
                (responseData) => {
                    //on error show 'may we suggest' instead
                    setFindmineData(processData(responseData));
                    console.log(responseData);
                    console.log('Failed to get findmine content');
                },
                mcID,
            );
        },
        [SelectedEdpItem, findmineAppID, processData],
    );
    const getECID = async () => {
        try {
            const result = await window.alloy('getIdentity');
            return result.identity.ECID;
        } catch (error) {
            console.log('Error retrieving ECID ' + 'error');
            console.log('find ecid error ');
            return '';
        }
    };
    const isValidCategory = (array) => {
        return array.some((element) => element === window['analyticsData'].page.category1DimensionId);
    };
    function checkAlloy() {
        return new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
                clearInterval(interval);
                reject('Timeout: alloy variable was not defined');
            }, 1500);

            const interval = setInterval(() => {
                if (typeof window.alloy !== 'undefined') {
                    clearInterval(interval);
                    clearTimeout(timeout);
                    resolve(true);
                }
            }, 100);
        });
    }
    const beacon = (action: string, set: number, item: number, currentSlide: number) => {
        const cookie: Cookie = new Cookie();
        let userEDP;
        let itemID = '';
        let setID = '';
        let setItemIDs = '';
        const interaction = `&interaction=${action}`;
        const responseID = `&response_uuid=${findmineData.response_uuid}`;
        if (action == 'item_click') {
            itemID = set != null ? `&item_id=${findmineData.looks[set].items[item].item_id}` : '';
            setID = `&set_id=${findmineData.looks[set].look_id}`;
            setItemIDs = findmineData.looks[set].items.map((item) => item.item_id).join(',');
            setItemIDs = `&set_item_ids=${setItemIDs}`;
        }
        if (action == 'next_click' || action == 'previous_click') {
            setID = `&set_id=${findmineData.looks[currentSlide].look_id}`;
            setItemIDs = findmineData.looks[currentSlide].items.map((item) => item.item_id).join(',');
            setItemIDs = `&set_item_ids=${setItemIDs}`;
        }
        if (
            cookie.UserAccessToken != undefined &&
            cookie.UserAccessToken.Token.length > 0 &&
            cookie.UserAccessToken.Edp > 0
        ) {
            userEDP = cookie.UserAccessToken.Edp;
        }
        const mcIDParam = mcid ? `&fm_session_id=${mcid}` : '';
        const customerID = userEDP ? `&customer_id=${userEDP}` : '';

        const apiBeacon = `https://api.findmine.com/api/v3/analytics?application=${findmineAppID}${setID}${setItemIDs}${interaction}${itemID}${responseID}${customerID}${mcIDParam}`;
        interface NewImage extends HTMLImageElement {
            callback: (...args: any[]) => void;
        }
        function createImage(): NewImage {
            return document.createElement('IMG') as NewImage;
        }
        const newImage = createImage();
        newImage.style.width = '1px';
        newImage.src = apiBeacon;
    };

    useEffect(() => {
        const findMineCategories = ['100101', '100047', '128153', '100071', '3002802', '100038', '100072'];
        async function checkAlloyThenGetData() {
            let alloyDefined = null;
            try {
                //check for Adobe Experience ID for analytics
                alloyDefined = await checkAlloy();
            } catch (error) {
                console.log(error);
            }
            if (isValidCategory(findMineCategories) && !isConsentCategoryDisabled('targeting')) {
                if (alloyDefined) {
                    const mcID = await getECID();
                    setMcid(mcID);
                    getFindMineData(mcID);
                } else {
                    getFindMineData(null);
                }
            } else {
                //unhide May We Suggest : Curated Product Recommendations
                unHideMayWeSuggest();
            }
        }

        checkAlloyThenGetData();
    }, [getFindMineData]);

    return (
        <>
            {ReactDOM.createPortal(
                <>{isLooksAvailable && <FindmineCarousel data={findmineData} beacon={beacon} />}</>,
                domNode,
            )}
        </>
    );
};

export default Findmine;
